import { type FC, useMemo } from 'react';

import { Box } from '@mui/material';

import LargeContainer from './components/LargeContainer';
import SmallContainer from './components/SmallContainer';

import type { RowWithTitleContainerProps } from '@shared/ui/containers/RowWithTitleContainer/types';

export const RowWithTitleContainer: FC<RowWithTitleContainerProps> = ({
  children,
  title,
  alignItems = 'center',
  titlePadding = 0,
  isFlexWidth,
  isRequired,
  variant = 'medium',
  titleInsideContainer,
  hideTitleOnMobileSmallContainer,
  descriptionLargeContainer,
  descriptionTypographyVariant,
  titleWidth,
  titleVariant,
  titleColor,
  customWidthLeftTitle,
  infoIconTooltipText,
  titleWithDotted,
  customTitleMarginBottom,
  hideRowTitle,
  descriptionLargeContainerWidth,
  customDisplayVariant,
}) => {
  const content = useMemo(() => {
    switch (variant) {
      case 'medium':
        return (
          <SmallContainer
            title={title}
            titlePadding={titlePadding}
            alignItems={alignItems}
            isRequired={isRequired}
            isFlexWidth={isFlexWidth}
            hideTitleOnMobileSmallContainer={hideTitleOnMobileSmallContainer}
            titleWidth={titleWidth}
            titleVariant={titleVariant}
            titleColor={titleColor}
            infoIconTooltipText={infoIconTooltipText}
            hideRowTitle={hideRowTitle}
            customDisplayVariant={customDisplayVariant}
          >
            {children}
          </SmallContainer>
        );
      case 'large':
        return (
          <LargeContainer
            title={title}
            titlePadding={titlePadding}
            alignItems={alignItems}
            titleVariant={titleVariant}
            isRequired={isRequired}
            isFlexWidth={isFlexWidth}
            titleInsideContainer={titleInsideContainer}
            descriptionLargeContainer={descriptionLargeContainer}
            descriptionTypographyVariant={descriptionTypographyVariant}
            customWidthLeftTitle={customWidthLeftTitle}
            infoIconTooltipText={infoIconTooltipText}
            titleWithDotted={titleWithDotted}
            customTitleMarginBottom={customTitleMarginBottom}
            descriptionLargeContainerWidth={descriptionLargeContainerWidth}
          >
            {children}
          </LargeContainer>
        );
      default:
        return <></>;
    }
  }, [
    variant,
    title,
    titlePadding,
    alignItems,
    isRequired,
    isFlexWidth,
    hideTitleOnMobileSmallContainer,
    titleWidth,
    titleVariant,
    titleColor,
    children,
    titleInsideContainer,
    descriptionLargeContainer,
    descriptionTypographyVariant,
    customWidthLeftTitle,
    infoIconTooltipText,
    customTitleMarginBottom,
    titleWithDotted,
    hideRowTitle,
    descriptionLargeContainerWidth,
    customDisplayVariant,
  ]);

  return <Box width="100%">{content}</Box>;
};
